import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, MenuItem } from "@mui/material";
import useTags from "../../hooks/useTags";
import PontoCorEtiqueta from "../PontoCorEtiqueta";

const TicketsTagSelect = ({ tag, onChange }) => {
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(tag || null);
  const { findAll: findAllTags } = useTags();

  useEffect(() => {
    const init = async () => {
      const listTags = await findAllTags();
      setTags(listTags);
    };
    init();
  }, []);

  useEffect(() => {
    setSelectedTag(tag || null);
  }, [tag]);

  const handleChange = (event, newValue) => {
    setSelectedTag(newValue);
    if (onChange) onChange(newValue ? newValue.id : "");
  };

  const render = () => {
    if (tags.length == 0) {
      return (<></>);
    }
    return (
      <Autocomplete
        options={tags}
        getOptionLabel={(option) => option.descricao}
        value={tags.find((option) => option.id === selectedTag) || null}
        onChange={handleChange}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        ListboxProps={{
          style: {
            maxHeight: 300,
            overflowY: 'auto',
            fontSize: '0.85rem',
          },
        }}
        sx={{
          fontSize: '0.85rem',
          '& .MuiAutocomplete-inputRoot': {
            padding: '4px !important',
            fontSize: '0.85rem',
          },
        }}
        renderOption={(props, option) => (
          <MenuItem {...props}
            dense
            sx={{
              fontSize: '0.85rem',
              minHeight: '32px',
              paddingY: 0.5,
            }}
            key={option.id}>
            <PontoCorEtiqueta cor={option.cor} />
            {option.descricao}
          </MenuItem>
        )}
        renderInput={(params) => (
          <TextField {...params} label="Filtrar por etiqueta" variant="outlined" margin="dense" sx={{
            '& input': {
              fontSize: '0.85rem',
            },
            '& label': {
              fontSize: '0.85rem',
            },
          }} />
        )}
      />
    );
  }

  return (
    render()
  );
};

export default TicketsTagSelect;
